import { __decorate, __metadata } from "tslib";
import { Injectable } from '@angular/core';
import { init, setUserId, track } from '@amplitude/analytics-browser';
import { environment } from '../../../../environments/environment';
var AmplitudeService = /** @class */ (function () {
    function AmplitudeService() {
        init(environment.amplitudeKey, {
            defaultTracking: false
        });
    }
    AmplitudeService.prototype.setUserDetail = function (userDetail) {
        setUserId(userDetail.user_id);
    };
    AmplitudeService.prototype.logEvent = function (eventDetail) {
        track(eventDetail.event, eventDetail.eventProperties);
    };
    AmplitudeService = __decorate([
        Injectable({
            providedIn: 'root'
        }),
        __metadata("design:paramtypes", [])
    ], AmplitudeService);
    return AmplitudeService;
}());
export { AmplitudeService };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYW1wbGl0dWRlLnNlcnZpY2UuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi8uLi93b3JrcGxhY2VMaXZpbmdTZXJ2aWNlcy9zcmMvYXBwL3NoYXJlZC91dGlsaXRpZXMvYW5hbHl0aWNzL2FtcGxpdHVkZS5zZXJ2aWNlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQSxPQUFPLEVBQUUsVUFBVSxFQUFFLE1BQU0sZUFBZSxDQUFDO0FBQzNDLE9BQU8sRUFBRSxJQUFJLEVBQUUsU0FBUyxFQUFFLEtBQUssRUFBRSxNQUFNLDhCQUE4QixDQUFDO0FBRXRFLE9BQU8sRUFBRSxXQUFXLEVBQUUsTUFBTSxzQ0FBc0MsQ0FBQztBQUtuRTtJQUVFO1FBQ0UsSUFBSSxDQUFDLFdBQVcsQ0FBQyxZQUFZLEVBQUU7WUFDN0IsZUFBZSxFQUFFLEtBQUs7U0FDdkIsQ0FBQyxDQUFDO0lBQ0wsQ0FBQztJQUVNLHdDQUFhLEdBQXBCLFVBQXFCLFVBQStCO1FBQ2xELFNBQVMsQ0FBQyxVQUFVLENBQUMsT0FBTyxDQUFDLENBQUM7SUFDaEMsQ0FBQztJQUVNLG1DQUFRLEdBQWYsVUFBZ0IsV0FBaUM7UUFDL0MsS0FBSyxDQUFDLFdBQVcsQ0FBQyxLQUFLLEVBQUUsV0FBVyxDQUFDLGVBQWUsQ0FBQyxDQUFDO0lBQ3hELENBQUM7SUFkVSxnQkFBZ0I7UUFINUIsVUFBVSxDQUFDO1lBQ1YsVUFBVSxFQUFFLE1BQU07U0FDbkIsQ0FBQzs7T0FDVyxnQkFBZ0IsQ0FlNUI7SUFBRCx1QkFBQztDQUFBLEFBZkQsSUFlQztTQWZZLGdCQUFnQiJ9